import { twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

import { desktop } from './desktop';

/**
 * Better Auth's client insists on an http or https base, and the Mac app's page
 * lives on `app://cairn`. There it is given an address under `.invalid`, a
 * name that can never resolve, and every request to it is rewritten to the
 * page's own `/api/auth`, which main forwards (docs/desktop-app.md).
 */
const desktopBase = 'https://app.cairn.invalid';

const toPage = (url: string) =>
  url.startsWith(desktopBase) ? url.slice(desktopBase.length) || '/' : url;

export const authClient = createAuthClient(
  desktop
    ? {
        baseURL: `${desktopBase}/api/auth`,
        fetchOptions: {
          customFetchImpl: (input, init) =>
            fetch(
              input instanceof Request
                ? new Request(toPage(input.url), input)
                : toPage(input.toString()),
              init,
            ),
        },
        plugins: [twoFactorClient()],
      }
    : { plugins: [twoFactorClient()] },
);
